import script from "./StoreAdminReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminReservations.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminReservations.vue?vue&type=style&index=0&id=4a885d72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a885d72"]])

export default __exports__